import React from 'react';
import { useField } from 'formik';
import { makeStyles } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';

import { requiredFields } from '../FormPage/FormPage';

const useStyles = makeStyles(theme => ({
  formControl: {
    display: 'block',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  select: {
    minWidth: 350,
  },
}));

type SelectFieldProps = {
  label: string,
  name: string,
  options: { name: string, value: string }[]
}

const SelectField = ({ label, name, options }: SelectFieldProps) => {
  const classes = useStyles();
    const [field, meta] = useField(name);
  const hasError = meta.touched && !!meta.error;
  const isRequired = requiredFields[name];

  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);
  React.useEffect(() => {
    // @ts-ignore
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  return (
    <FormControl className={classes.formControl} error={hasError} variant="outlined">
      <InputLabel htmlFor={name} id={name + 'Label'} ref={inputLabel}>
        {label} {!isRequired && <Typography variant="caption">(optional)</Typography>}
      </InputLabel>
      <Select
              {...field}
              value={field.value || ''} //bug fix, or value won't load from api
        className={classes.select}
        labelId={name + 'Label'}
        labelWidth={labelWidth}
        name={name}
      >
        {options.map(({ name, value}) => (
          <MenuItem key={value} value={value}>{name}</MenuItem>
        ))}
      </Select>
      {hasError && (
        <FormHelperText>{meta.error}</FormHelperText>
      )}
    </FormControl>
  );
}

export default SelectField;
